const isLocalhost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

const defaultBaseUrl = isLocalhost
    ? 'http://localhost:8080/api'
    : `${window.location.origin}/api`;

const apiConfig = {
    baseUrl: process.env.REACT_APP_API_BASE_URL || defaultBaseUrl,
};

export default apiConfig;
